var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnthropicLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 578.84,
    height: 65,
    viewBox: "0 0 578.84 65",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Anthoropic_logo",
    transform: "translate(2251 3663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M99.6,44.8,71.3.8H56V63.6H69v-44l28.3,44h15.3V.8h-13v44Z",
    transform: "translate(-2232.7 -3662.73)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M106.8,12.9h21.1V63.6h13.5V12.9h21.1V.8H106.8V12.9Z",
    transform: "translate(-2216.13 -3662.73)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M200,25.9H170.4V.9H156.9V63.7h13.5V38H200V63.7h13.5V.8H200V25.9Z",
    transform: "translate(-2199.77 -3662.73)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M225.5,12.9h16.6c6.6,0,10.1,2.4,10.1,7s-3.5,7-10.1,7H225.5v-14ZM265.7,20c0-11.9-8.7-19.1-23-19.1H212V63.7h13.5V39.1h15L254,63.7h14.9L254,37.2c7.5-2.9,11.7-8.9,11.7-17.2Z",
    transform: "translate(-2181.76 -3662.73)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M291.2,52.4c-10.6,0-17.1-7.5-17.1-19.8,0-12.5,6.5-20,17.1-20,10.5,0,16.9,7.5,16.9,20,0,12.3-6.4,19.8-16.9,19.8Zm0-52.4c-18.1,0-31,13.5-31,32.6,0,18.9,12.8,32.4,31,32.4,18,0,30.8-13.5,30.8-32.4C322,13.5,309.3,0,291.2,0Z",
    transform: "translate(-2166.01 -3663)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M346.4,28.7H329.8V12.9h16.6c6.6,0,10.1,2.7,10.1,7.9s-3.4,7.9-10.1,7.9ZM347,.8H316.3V63.6h13.5V40.9H347c14.3,0,23-7.5,23-20S361.3.8,347,.8Z",
    transform: "translate(-2147.71 -3662.73)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M436.5,42.8c-2.3,6.1-7,9.6-13.4,9.6-10.6,0-17.1-7.5-17.1-19.8,0-12.5,6.5-20,17.1-20,6.4,0,11,3.5,13.4,9.6h14.3C447.2,8.7,436.7,0,423.1,0c-18.1,0-31,13.5-31,32.6,0,18.9,12.8,32.4,31,32.4,13.7,0,24.2-8.8,27.7-22.2Z",
    transform: "translate(-2122.96 -3663)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M360.9.8,386,63.6h13.7L374.6.8Z",
    transform: "translate(-2133.17 -3662.73)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M23.7,38.8l8.6-22.1,8.6,22.1ZM25.1.8,0,63.7H14l5.1-13.2H45.3l5.1,13.2h14L39.4.8Z",
    transform: "translate(-2251 -3662.73)",
    fill: "#181818"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnthropicLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Anthropic_logo.63c40f76fdff4a6d4c5ca144acc630f6.svg";